import styled from "@emotion/styled";
import { ParlorDetailProps } from "@/types/parlor";
import Map from "./Map";
import ParlorSeoTextSection from "./ParlorSeoTextSection";

function AmenityInfoTabPanelMayVersion({
  parlor,
  closestParlors,
  nearbyFacilities,
}: {
  parlor: ParlorDetailProps;
  closestParlors?: any;
  nearbyFacilities?: any;
}) {
  return (
    <>
      <AmenityInfoTabPanelRoot>
        <h2 className="subtitle_18_sb">장례식장 위치 정보</h2>
        <p className="caption_12_r" style={{ color: "#888", marginTop: "4px" }}>
          {parlor?.companyname}의 정확한 위치를
          <br />
          네이버 지도를 통해 정확하게 확인하실 수 있어요.
        </p>
        <div style={{ marginTop: "12px" }} />
        <Map parlor={parlor} />
      </AmenityInfoTabPanelRoot>
      <ParlorSeoTextSection
        parlor={parlor}
        closestParlors={closestParlors}
        nearbyFacilities={nearbyFacilities}
      />
    </>
  );
}

const AmenityInfoTabPanelRoot = styled.div`
  padding: 19px 19px 40px; ;
`;

export default AmenityInfoTabPanelMayVersion;
